import { render, staticRenderFns } from "./Setup_Gallery.vue?vue&type=template&id=7fd71d85&scoped=true&"
import script from "./Setup_Gallery.vue?vue&type=script&lang=js&"
export * from "./Setup_Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Setup_Gallery.vue?vue&type=style&index=0&id=7fd71d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd71d85",
  null
  
)

export default component.exports